module.exports = __webpack_public_path__ + "media/images/states/sc-red-56797927b7ca62ea8319630fc3038f10.png";